export default function Impressum() {
  return (
    <div className="mx-auto max-w-3xl px-5 py-16 lg:px-8 lg:py-24" data-testid="impressum-page">
      <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary">Rechtliches</span>
      <h1 className="mt-3 font-display text-4xl font-bold sm:text-5xl">Impressum</h1>
      <p className="mt-3 text-sm text-muted-foreground">Angaben gemäß § 5 TMG</p>

      <section className="mt-10 space-y-2 text-base">
        <h2 className="font-display text-lg font-semibold">Anbieter</h2>
        <p>
          Computer Hellen<br />
          Dipl.-Ing. Alexander Hellen<br />
          Dinkelweg 21<br />
          47638 Straelen<br />
          Deutschland
        </p>
      </section>

      <section className="mt-8 space-y-2 text-base">
        <h2 className="font-display text-lg font-semibold">Kontakt</h2>
        <p>
          Telefon:{" "}
          <a className="text-primary hover:underline" href="tel:028349448700" data-testid="impressum-phone">
            02834 9448700
          </a>
          <br />
          E-Mail:{" "}
          <a
            className="text-primary hover:underline"
            href="mailto:info@computerhellen.de"
            data-testid="impressum-email"
          >
            info@computerhellen.de
          </a>
        </p>
      </section>

      <section className="mt-8 space-y-2 text-base">
        <h2 className="font-display text-lg font-semibold">Umsatzsteuer</h2>
        <p>Steuernummer: 113/5063/1634</p>
      </section>

      <section className="mt-8 space-y-2 text-base">
        <h2 className="font-display text-lg font-semibold">Berufsbezeichnung</h2>
        <p>
          Berufsbezeichnung: Diplom-Ingenieur Elektrotechnik<br />
          Verliehen in: Bundesrepublik Deutschland, Universität Duisburg-Essen
        </p>
      </section>

      <section className="mt-8 space-y-2 text-base">
        <h2 className="font-display text-lg font-semibold">
          Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
        </h2>
        <p>
          Alexander Hellen<br />
          Dinkelweg 21<br />
          47638 Straelen
        </p>
      </section>

      <section className="mt-8 space-y-2 text-base">
        <h2 className="font-display text-lg font-semibold">EU-Streitschlichtung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
          bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            https://ec.europa.eu/consumers/odr/
          </a>
          . Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
      </section>

      <section className="mt-8 space-y-2 text-base">
        <h2 className="font-display text-lg font-semibold">
          Verbraucherstreitbeilegung / Universalschlichtungsstelle
        </h2>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      <section className="mt-8 space-y-2 text-base">
        <h2 className="font-display text-lg font-semibold">Haftung für Inhalte</h2>
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten
          nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
          Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
          Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
          rechtswidrige Tätigkeit hinweisen.
        </p>
      </section>

      <section className="mt-8 space-y-2 text-base">
        <h2 className="font-display text-lg font-semibold">Haftung für Links</h2>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
          keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
          Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
          Anbieter oder Betreiber der Seiten verantwortlich.
        </p>
      </section>

      <section className="mt-8 space-y-2 text-base">
        <h2 className="font-display text-lg font-semibold">Urheberrecht</h2>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
          unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung
          und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
          schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
        </p>
      </section>
    </div>
  );
}
